var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterOnLot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 13",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9361 1.85086C25.521 3.21072 24.1425 -0.0625756 20.8651 2.55606C16.0674 6.39256 14.9397 -1.04697 10.6124 2.47423C8.76703 3.9761 6.77461 4.01942 4.94304 2.47183C2.08067 0.0505458 0.672834 2.99892 0.112467 1.93751C-0.546484 0.685951 2.47154 -1.25155 5.4152 1.13844C6.95275 2.38518 8.63385 2.40203 10.1766 1.13844C11.9788 -0.339362 14.0006 -0.406753 15.8097 1.10955C17.3074 2.36592 18.9643 2.47183 20.5036 1.16732C23.1965 -1.11677 26.365 0.445267 25.9361 1.85327V1.85086Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2908 10.8284C21.5741 8.13272 19.7961 14.8863 15.3997 11.1677C13.8535 9.85842 12.0617 9.94025 10.5189 11.2135C8.75137 12.6744 6.72955 12.672 4.9637 11.1533C2.05982 8.655 0.465199 11.9042 0.0328168 10.4337C-0.364975 9.08101 2.89346 7.63209 5.53099 9.87526C7.02357 11.1437 8.677 11.0498 10.1886 9.82713C11.9821 8.37581 14.0627 8.34452 15.8424 9.83435C17.297 11.0522 18.9072 11.1076 20.3946 9.87526C22.5651 8.07736 25.8529 8.50818 25.9965 10.3061C26.019 10.5805 25.4776 10.9632 25.2874 10.826L25.2908 10.8284Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3168 6.4744C21.2144 3.6584 20.3444 10.6936 15.1904 6.69583C13.6979 5.53814 12.1032 5.58146 10.6366 6.77525C8.81194 8.26027 6.76591 8.34933 4.94472 6.78007C2.11521 4.34194 0.356279 7.51897 0.0380462 6.13504C-0.307859 4.62835 2.97824 3.38161 5.29062 5.37447C9.5591 9.05453 10.8597 1.81717 15.5882 5.26857C17.6222 6.75359 18.6028 7.01353 20.8339 5.25413C23.065 3.49473 26.3009 4.58022 25.9533 6.17836C25.9049 6.39738 25.4829 6.58752 25.3168 6.4744Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 12.3158,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterOnLot);
export default __webpack_public_path__ + "static/media/water-on-lot.0a2b9f59abb7d0506ebd4e9f7193fcc5.svg";
export { ForwardRef as ReactComponent };